export const SET_IS_RE_SENDING_EMAIL = 'emailVerificationComponent.setIsReSendingEmail'

export function setIsReSendingEmail(payload: boolean) {
  return {
    type: SET_IS_RE_SENDING_EMAIL,
    payload
  } as const
}

export type EmailVerificationAction = ReturnType<typeof setIsReSendingEmail>
